import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

export default async (data) => {

    if (data.key) {
        const result = await axiosPublicClient.post(`/save-applicant-progress`, data)

        return result.data
    }

    const result = await axiosClient.post(`/save-applicant-progress`, data)

    return result.data


}
